import { styled } from 'styled-components';
import { TypeStyle } from '../TypeStyle';
export const BreadcrumbLink = styled.a `
  text-decoration: underline;
  text-decoration-thickness: 0.5px;
  text-underline-offset: 1.5px;
  color: ${o => o.theme.color.text.secondary.on.background};
  &:hover {
    text-decoration: none;
  }
`;
export const BreadcrumbsWrapper = styled.ol `
  display: flex;
  flex-wrap: wrap;
`;
export const BreadcrumbsTextLi = styled.li `
  ${TypeStyle.css.headlineMicro};
  display: flex;
  white-space: nowrap;
`;
//# sourceMappingURL=styles.js.map